import { gql, useQuery } from '@apollo/client';
import {
  GetPushesByBrandKeyQuery,
  GetPushesByBrandKeyQueryVariables,
} from '../../../__generated__/queries-web';

export const GET_PUSH_BY_BRANDKEY = gql`
  query getPushesByBrandKey(
    $first: UnsignedInt!
    $skip: UnsignedInt
    $where: PushFilterInput
    $orderBy: [PushOrderingInput!]
  ) {
    pushCount(where: $where)
    pushes(first: $first, skip: $skip, where: $where, orderBy: $orderBy) {
      id
      title
      article {
        id
        title
        brandKey
        format
      }
      userId
      user {
        name
        id
      }
      sentAt
      targetDevice
      scheduledAt
      segments(first: 10) {
        segment {
          title
          id
        }
      }
    }
  }
`;

export const useGetPushCount = (id: string) => {
  const { data } = useQuery<
    GetPushesByBrandKeyQuery,
    GetPushesByBrandKeyQueryVariables
  >(GET_PUSH_BY_BRANDKEY, {
    variables: {
      first: 25,
      where: {
        article: {
          id,
        },
      },
    },
    skip: !id,
  });

  return data?.pushCount;
};
